export default function getFromQueryString(string, paramName) {
  const query = getQueryFromString(string);
  return query[paramName];
}

function getQueryFromString(queryString = "") {
  if (!queryString.length) {
    return {};
  }
  return JSON.parse(
    '{"' +
      decodeURI(queryString)
        .replace("?", "")
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"') +
      '"}'
  );
}
